import { tutoringApiUrl } from './utils';

export const getTutorWeeklySessionsByStartEndDate = async (
  // tutorId: string, // IES id
  from: string,
  to: string,
  offset: number,
  token: string,
) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ from, to, offset }),
  };

  try {
    const group = await fetch(`${tutoringApiUrl()}/tutors/getWeeklySessions`, requestOptions);
    return await group.json();
  } catch (e) {
    console.log('error:', e);
    return undefined;
  }
};

export const getTutorByIesId = async (
  // iesId: string, // IES id
  token: string,
) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const resp = await fetch(`${tutoringApiUrl()}/tutors/getTutor`, requestOptions);
    return await resp.json();
  } catch (e) {
    console.log('error:', e);
    return undefined;
  }
};
